import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trophy, Users } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n";
import { Avatar } from "@/components/SearchPage";

const MEDAL = ["#f59e0b", "#9fb0a4", "#c47a3a"];

export default function InviteLeaderboard() {
  const { user } = useAuth();
  const { t } = useT();
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/referrals/leaderboard").then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, []);

  return (
    <section className="px-4 sm:px-6 mt-12" data-testid="invite-leaderboard">
      <div className="bg-white rounded-3xl border border-[#e5dfd3] card-shadow p-7 sm:p-9">
        <div className="flex items-center gap-2">
          <Trophy className="w-5 h-5 text-[#d97706]" />
          <h2 className="font-head text-base md:text-lg font-bold text-[#d97706] uppercase tracking-wider">{t("lb_title")}</h2>
        </div>
        <p className="text-sm text-[#5f6b62] mt-1">{t("lb_sub")}</p>
        {rows === null ? null : rows.length === 0 ? (
          <p className="mt-6 text-[#5f6b62] flex items-center gap-2" data-testid="leaderboard-empty"><Users className="w-4 h-4" /> {t("lb_empty")}</p>
        ) : (
          <ol className="mt-5 grid sm:grid-cols-2 gap-2">
            {rows.map((r, i) => {
              const me = r.id === user?.id;
              return (
                <li key={r.id}>
                  <button onClick={() => navigate(me ? "/profilo" : `/utente/${r.id}`)} data-testid="leaderboard-row"
                    className={`w-full flex items-center gap-3 p-3 rounded-2xl border transition-all hover:border-[#d97706] text-left ${me ? "border-[#d97706] bg-[#fef3c7]" : "border-[#f0ebe0] bg-[#fdfbf7]"}`}>
                    <span className="w-8 h-8 rounded-full flex items-center justify-center font-mono font-bold text-sm text-white shrink-0" style={{ background: MEDAL[i] || "var(--primary)" }}>{i + 1}</span>
                    <Avatar u={r} size="w-10 h-10 text-base" />
                    <span className="min-w-0 flex-1">
                      <span className="block font-head font-bold truncate">{r.name} {me && <span className="text-xs font-normal text-[#92600a]">({t("lb_you")})</span>}</span>
                      <span className="block text-xs font-mono text-[#5f6b62]">@{r.username}</span>
                    </span>
                    <span className="font-mono font-extrabold text-[#1e3326] text-lg shrink-0" data-testid="leaderboard-count">{r.count} <span className="text-xs font-normal text-[#5f6b62]">{t("lb_invites")}</span></span>
                  </button>
                </li>
              );
            })}
          </ol>
        )}
      </div>
    </section>
  );
}
